import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import utils from "ulysses/widgets/search/utils";
import popover from "ulysses/widgets/search/label_popover.html";
import popover_title from "ulysses/widgets/search/label_popover_title.html";

function _manage_addresses(item) {
    //copy the data to show dialog. once dialog shown, sever communication with item.
    var data = {
        actions: (item.actions_by_set() || {}).addresses,
        addresses: ko.observableArray(item.addresses()),
        page_resource: {
            "_links": item._links,
            "unique_id": ko.unwrap(item.unique_id)
        }
    };
    //subscribe to entity changes to refresh the dialog.
    var _sub = uly.subscribe("socket.subscription.changed." + item.unique_id, function () {
        refresh_addresses(HalResource(data.page_resource), data.addresses);
    });
    //show the dialog
    uly.dialogs
        .execute($("#addresses-dialog").html(), {
            "title": _("search_title_addresses", "Addresses"),
            "raw_data": true
        }, data)
        .always(function () {
            uly.unsubscribe(_sub);
        });

}
function _manage_attachments(item) {
    //copy the data to show dialog. once dialog shown, sever communication with item.
    var data = {
        media: ko.observableArray(item.media()),
        page_resource: {
            "_links": item._links,
            "unique_id": ko.unwrap(item.unique_id)
        }
    };
    //subscribe to entity changes to refresh the dialog.
    var _sub = uly.subscribe("socket.subscription.changed." + item.unique_id, function () {
        refresh_media(HalResource(data.page_resource), data.media);
    });
    //show the dialog
    uly.dialogs
        .execute($("#media-dialog").html(), {
            "title": _("search_title_attachments", "Attachments"),
            "raw_data": true
        }, data)
        .always(function () {
            uly.unsubscribe(_sub);
        });
}

function _manage_details(item, ev, ui) {
    var detail = ui.model;
    var data = {
        detail: detail,
        page_resource: {
            "_links": item._links,
            "unique_id": ko.unwrap(item.unique_id),
            "id": item.id
        }
    };
    uly.dialogs
        .execute($("#detail-dialog").html(), {
            "title": _("search_title_detail", "Detail"),
            "raw_data": true
        }, data);
}

function _activate_label(item, label, ev) {
    console.log("activate label:", ev, label);
    $(ev.target).popover({
           content: popover.format(label),
           title: popover_title.format(label),
           html: true,
           trigger: "click"
    }).popover("toggle");
}

export function fetch_item_actions(item_res) {
    return item_res.then((item)=> {
        var def = Promise.Deferred();
        item_res.follow_with_cache("uly:default_action", uly.api.action_cache).then(function (action) {
            def.resolve(action);
        }, function (error) {
            def.resolve(null);
        });
        return Promise.when(
            item_res.follow_with_cache("uly:actions", uly.api.action_cache, true),
            def
        ).then(function ([actions, default_action]) {
            if (item.can_bookmark)
                actions = [{
                    "set": "main",
                    "caption": _("search_caption_follow", "Follow"),
                    "icon": "fa fa-star-o",
                    "name": "follow",
                    "colour": item.model_colour
                }].concat(actions);
            else if (item.can_unbookmark)
                actions = [{
                    "set": "main",
                    "caption": _("search_caption_unfollow", "Unfollow"),
                    "icon": "fa fa-star",
                    "name": "unfollow",
                    "colour": item.model_colour
                }].concat(actions);

                var actions_by_set = uly.actions.classifyActions(ko.toJS(actions), item, true);
            var actions = $.map(["shortcut", "workflow", "main", "default"], function (key) {
                if (actions_by_set[key] && actions_by_set[key].length)
                    return [{
                        "separator": true
                    }].concat(actions_by_set[key]);
                return null;
            }).slice(1);

            return {
                "by_set": actions_by_set,
                "actions": actions,
                "default_action": default_action || actions[0]
            };
        });

    });

}

export function searchify_item(item, is_master) {
    Object.assign(this, item);
    let that = this;
    this.url = item._links && item._links.self ? item._links.self.href : null;
    this.actions = ko.observableArray([]);
    this.bulk_actions = ko.observableArray([]);
    this.shortcut_actions = ko.observableArray([]);
    this.default_action = ko.observable(null);
    this.timers = ko.observableArray([]);
    this.labels = utils.uniquify_labels(item.labels || []);
    this.actions_by_set = ko.observable(null);

    this.actorinfo = ko.observableArray([]);
    this.details = ko.observableArray([]);
    this.addresses = ko.observableArray([]);
    this.media = ko.observableArray([]);
    this.note_panel_visible = ko.observable(false);


    this.is_active = ko.pureComputed( () => {
        if (is_master && !this.unique_id)
            return false;
        return uly.page.active_entity_id() && (uly.page.active_entity_id() == this.unique_id);
    });

    this.is_active._subscribe = this.is_active.subscribe;
    this.is_active.subscribe = function(a,b,c) {
        return that.is_active._subscribe(a,b,c);
    }

    this._dispose = () => {
        that.is_active.dispose();
    }
    this.can_show_addresses = ko.pureComputed(function () {
        var address_actions = (that.actions_by_set() || {}).addresses;
        if (!address_actions || !address_actions.length) return false;
        return true;
    });

    this.is_active.subscribe((newvalue) => {
        if (!newvalue) {
            that.note_panel_visible(false);
        }
    });
    
    var item_res = HalResource(item);
    var is_shown = false;
    this.manage_addresses = function(ev, ui) { return _manage_addresses(that, ev, ui); };
    this.manage_attachments = function(ev,ui) { return _manage_attachments(that, ev, ui); };
    this.manage_detail = function(ev,ui) { return _manage_details(that, ev, ui); };
    this.dropdown_extra_menu = function (ui, ev) {
        if (is_shown) return true;
        is_shown = true;

        // refresh_media(item_res, this.media);
        if (that.can_show_addresses())
            refresh_addresses(item_res, that.addresses);

        var hal_model = item_res.follow("uly:model", {
            "details": true,
            "attributes": '',
            "favourites": '',
            "relations": ''
        });

        hal_model.follow("uly:actorinfo")
            .follow("uly:datatable", {
                "rel": that.id
            })
            .then(function (datatable) {
                that.actorinfo(datatable.data);
            });
        if (uly.page.app_settings.show_details_menu()) {
             hal_model
                .follow("uly:details")
                .then(function (details) {
                that.details(details.map(function (detail) {
                    detail.edit = that.manage_detail;
                    return detail;
                }));
            });
        }
        return true;
    };
    this.has_extra_menu = ko.pureComputed(() => {
        if (that.can_show_addresses()) {
            return true;
        }
        if (that.actorinfo().length) {
            return true;
        }
        if (that.details().length > 0) {
            return true;
        }
        return false;
    })

    fetch_item_actions(item_res).then((result)=> {
        that.actions_by_set(result.by_set);
        var actions_by_set = that.actions_by_set();
        that.actions(result.actions);
        that.bulk_actions(result.by_set.bulk_actions);
        that.shortcut_actions(result.by_set.shortcut);
        that.default_action(result.default_action);
    })

    item_res.follow("uly:timers").done(function (timers) {
        that.timers(timers);
    });
    this.collapsed = ko.observable(!(is_master && !item.unique_id));
    this.toggle_row = function () {
        this.collapsed(!this.collapsed());
    };
    this.action_bar_shown = ko.pureComputed(function () {
        var expanded = !that.collapsed();
        var active = that.is_active();
        return expanded || active;
    });
    this.activate_label = _activate_label;
    return this;
}


function refresh_addresses(resource, addresses) {
    addresses([]);
    resource.follow("uly:addresses").follow("item").then(function (results) {
        $(results).each(function () {
            var $this = this;
            HalResource($this)
                .follow_with_cache("uly:actions", uly.api.action_cache)
                .then(function (actions) {
                    $this.actions = uly.actions.classifyActions(actions, $this, true);
                    addresses.push($this);
                }).fail(function () {
                    addresses.push($this);
                });
        });
    });
}

function _get_extension(mediafile) {
    var filename = ko.unwrap(mediafile.filename);
    var ext = filename.slice(filename.lastIndexOf(".") + 1, filename.length);
    if (ext == "doc" || ext == "docx") {
        return "DOC";
    }
    if (ext == "csv" || ext == "xls" || ext == "xlsx") {
        return "XLS";
    }
    if (ext == "txt" || ext == "text")
        return "TXT";
    return ext.toUpperCase();
}

function refresh_media(resource, media) {
    resource.follow("uly:media").done(function (result) {
        var media_items = result._embedded.item;
        var res = [];
        $.each(media_items, function (idx, mediafile) {
            res.push($.extend({}, mediafile, {
                "extension": _get_extension(mediafile),
                "name": mediafile.name || mediafile.filename,
                "url": mediafile._links.self.href
            }));
        });
        media(res);
    });

}


export default { searchify_item, fetch_item_actions };

